import React from 'react';

import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { black } from '../../constants/Colors';

const styles = {
  approveButton: {
    '@media screen and (max-width:480px)': {
      width: '148px'
    },
    border: `1px solid #757575`,
    borderRadius: '4px',
    boxShadow: 'none',
    color: '#757575',
    height: '36px',
    marginRight: '16px',
    width: '200px'
  },
  buttons: {
    display: 'flex',
    marginTop: '24px',
    textAlign: 'center'
  },
  description: {
    marginTop: '16px'
  },
  descriptionText: {
    color: '#757575',
    fontSize: '12px',
    textAlign: 'center'
  },
  title: {
    color: black,
    fontSize: '14px',
    textAlign: 'center'
  }
};

const RejectionPublisherPanel = (): React.ReactElement => {
  const { t } = useTranslation();

  return (
    <>
      <Typography sx={styles.title}>{t('message.rejected')}</Typography>
      <Typography sx={styles.description}>
        <Typography sx={styles.descriptionText}>
          {t('message.rejectedMessage')}
        </Typography>
      </Typography>
    </>
  );
};
export default RejectionPublisherPanel;
